const state = {
  deviceWidth: 0,
  isUserEditDialog: false,
  appSeoInfo: {},
  abTestInfo: {},
  isFrom: '',
  isAICreating: false
};

const mutations = {
  RESET_DEVICE_WIDTH: (state, width) => {
    state.deviceWidth = width;
  },
  IS_USER_EDIT_DIALOG: (state, isShow) => {
    state.isUserEditDialog = isShow;
  },
  SET_APP_SEO_INFO: (state, info) => {
    state.appSeoInfo = info;
  },
  SET_AB_TEST_INFO: (state, info) => {
    state.abTestInfo = info;
  },
  SET_IS_FROM: (state, isFrom) => {
    state.isFrom = isFrom;
  },
  SET_IS_AI_CREATING: (state, isAICreating) => {
    state.isAICreating = isAICreating;
  }
};

const actions = {
  resetDeviceWidth({ commit }, width) {
    commit('RESET_DEVICE_WIDTH', width);
  },
  setAppSeoInfo({ commit }, info) {
    commit('SET_APP_SEO_INFO', info);
  },
  setABTestInfo({ commit }, info) {
    commit('SET_AB_TEST_INFO', info);
  },
  setIsFrom({ commit }, isFrom) {
    commit('SET_IS_FROM', isFrom);
  },
  setIsAICreating({ commit }, isAICreating) {
    commit('SET_IS_AI_CREATING', isAICreating);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
